import script from "./dropdownInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./dropdownInput.vue?vue&type=script&setup=true&lang=ts"

import "./dropdownInput.vue?vue&type=style&index=0&id=65d2bc85&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d2bc85"]])

export default __exports__